import AcrylicPlateCreateEditComponent from 'src/components/features/superAdmin/acrylicPlateCreateEditComponent';

const CreateEditAcrylicPlatePage = () => <AcrylicPlateCreateEditComponent />;

export default CreateEditAcrylicPlatePage;
